import { catchError } from "../../utils/Helper";
import { centralTask } from "../axios/endpoint";
import { getRequest, postRequest, putRequest, deleteRequest } from "../axios/request";

export const getAllCentralTasks = async (query) => {
  try {
    const response = await getRequest(centralTask.getAllTasks, query);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const createCentralTask = async (payload) => {
  try {
    const response = await postRequest(centralTask.createTask, payload);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const updateCentralTask = async (id, payload) => {
  try {
    const response = await putRequest(centralTask.updateTaskById(id), payload);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const deleteCentralTask = async (id) => {
  try {
    const response = await deleteRequest(centralTask.deleteTaskById(id));
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const getCentralTaskProducts = async (id) => {
  try {
    const response = await getRequest(centralTask.getTaskProducts(id));
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const centralTaskApi = {
  getAllCentralTasks,
  createCentralTask,
  updateCentralTask,
  deleteCentralTask,
  getCentralTaskProducts,
};